import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";
import { requestWithToast } from "../../../../utils/request";
import { api } from "../api";

export const Delete = ({ isOpen, onClose, selectedChain: { id, chainName } }) => {
  const primaryBtnHandler = () => {
    requestWithToast(api.removeChain, { id });
    onClose();
  };

  return (
    <MainModal
      parentSelector=".chains"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Delete"
      headerCloseHandler={onClose}
      width={400}
      height="auto"
      primaryButtonText="Delete"
      primaryBtnHandler={primaryBtnHandler}
      primaryButtonClass="critical"
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      containerClassName="dialog"
    >
      Are you sure to delete <span className="text-bold">{chainName}</span> chain?
    </MainModal>
  );
};
